import PropTypes from 'prop-types'
import { cn } from 'lib/utils'

const spacingToGap = {
  1: 'gap-2',
  2: 'gap-4',
  3: 'gap-6',
  4: 'gap-8',
  5: 'gap-10',
  6: 'gap-12',
  7: 'gap-14',
  8: 'gap-16',
  10: 'gap-20',
  12: 'gap-24'
}

export const AdasStack = ({ children, className, direction = 'column', spacing, ...props }) => {
  const directionClass = direction === 'row' ? 'flex-row' : 'flex-col'
  const gapClass = spacing ? spacingToGap[spacing] || 'gap-4' : ''
  return (
    <div className={cn('flex', directionClass, gapClass, className)} {...props}>
      {children}
    </div>
  )
}

AdasStack.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  direction: PropTypes.oneOf(['row', 'column']),
  spacing: PropTypes.number
}
